module.exports = __webpack_public_path__ + "frontend/images/agents/mr-tan-dedicated-e0784068bd00cc62cb0634fdc30649ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/agents/mr-tan-dedicated.jpg
// module id = 356
// module chunks = 2